import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RequestsService {
  constructor(private http: HttpClient) {}

  getDatacreditoInfo(id: number) {
    return this.http.get<any>(
      environment.url +
        environment.Customer +
        '/getDatacreditoInfo?customerId=' +
        id,
    );
  }

  getByDocumentNumber(document: string) {
    return this.http.get<any>(
      environment.url +
        environment.Customer +
        '/getByDocumentNumber?documentNumber=' +
        document,
    );
  }

  getClient(id) {
    return this.http.get<any>(
      environment.url + environment.Customer + '/get?id=' + id,
    );
  }

  rejectCredit(taskId: string) {
    return this.http.post<any>(
      environment.url + environment.Credit + '/RejectSelfTask',
      taskId,
    );
  }

  deleteFile(id) {
    return this.http.get<any>(
      environment.url + environment.File + environment.delete + '?id=' + id,
    );
  }

  getCredit(id) {
    return this.http.get<any>(
      environment.url + environment.Credit + environment.get + '?id=' + id,
    );
  }

  getCreditRequestById(id) {
    return this.http.get<any>(
      environment.url + environment.Customer + '/getCreditRequestById?id=' + id,
    );
  }

  getConsultDataCredito(
    documentType: string,
    documentNumber: string,
    token: string,
  ) {
    return this.http.get<any>(
      environment.url_datacredito +
        '/DataCredito/' +
        documentType +
        '/' +
        documentNumber +
        '?token=' +
        token,
    );
  }

  getValuesCredit(objcredit) {
    return this.http.get<any>(
      environment.url +
        environment.Credit +
        environment.calculateCredit +
        '?amount=' +
        objcredit.amount +
        '&commission=' +
        objcredit.commission +
        '&interest=' +
        objcredit.interest +
        '&installments=' +
        objcredit.installments +
        '&signatureQuantity=' +
        objcredit.signatureQuantity,
    );
  }

  getAllInfo() {
    return this.http.get<any>(
      environment.url + environment.Customer + '/GetAllPendingInfo',
    );
  }

  get(id: string) {
    return this.http.get<any>(
      environment.url +
        environment.Customer +
        '/GetPendingCustomerInfoById' +
        '?documentNumber=' +
        id,
    );
  }

  getCodebt(id: string) {
    return this.http.get<any>(
      environment.url +
        environment.Customer +
        '/GetPendinCodebtInfoById' +
        '?documentNumber=' +
        id,
    );
  }

  getPendingInfo(id: number) {
    return this.http.get<any>(
      environment.url +
        environment.Customer +
        '/GetCreditPendingInfoById' +
        '?documentNumber=' +
        id,
    );
  }

  postCreateUserRequest(document: number) {
    return this.http.post<any>(
      `${environment.url}${environment.Customer}/CreateClientRequest`,
      document, // Enviar el valor directamente
      { headers: { 'Content-Type': 'application/json' } },
    );
  }

  CodebtorPending(document: number) {
    return this.http.post<any>(
      `${environment.url}${environment.Customer}/PendingCodebtor`,
      document, // Enviar el valor directamente
      { headers: { 'Content-Type': 'application/json' } },
    );
  }

  ApproveRequest(request: any) {
    return this.http.post<any>(
      environment.url + environment.Credit + '/ApproveRequestCredit',
      request,
    );
  }

  CreateCreditRequest(id: string) {
    return this.http.post<any>(
      environment.url + environment.Credit + '/CreateCreditRequest',
      id,
    );
  }

  getSettings() {
    return this.http.get<any>(environment.url + environment.Settings + '/get');
  }

  updateRequestCustomerCredit(request: any) {
    return this.http.post<any>(
      environment.url + environment.Customer + '/updateRequestCustomerCredit',
      request,
    );
  }

  payRequest(id: string) {
    return this.http.post<any>(
      environment.url + '/Customer/payRequest?requestId=' + id,
      id,
    );
  }

  consultDataCredito(payload: any) {
    return this.http.post<any>(
      environment.url_datacredito + '/DataCredito/consult',
      payload,
    );
  }

  updateCoDebtorDatacreditoInfo(payload: any) {
    return this.http.patch<any>(
      environment.url + environment.Customer + '/updateCoDebtorDatacreditoInfo',
      payload,
    );
  }
}
